import * as React from "react";
import UserList from "../../components/UserList";
import UsersQuery from "src/queries/UsersQuery";

export default () => (
  <UsersQuery>
    {({ loading, error, data }) => {
      if (!data) {
        return null;
      }
      if (error) {
        return <h1>ERROR</h1>;
      }
      return <UserList users={data.users} loading={loading} />;
    }}
  </UsersQuery>
);



// WEBPACK FOOTER //
// ./src/screens/AllUsers/ListUsersPage.tsx